import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { untilDestroyed, UrlParamsService } from '@app/core';
import { User, SignatureSessionBehaviorEnum } from '@app/models';
import { AppService, UserService, WhitelabelService } from '@app/services';
import { Router } from '@angular/router';

@Component({
  selector: 'app-document-sidebar-header',
  templateUrl: './document-sidebar-header.component.html',
  styleUrls: ['./document-sidebar-header.component.scss'],
  standalone: false
})
export class DocumentSidebarHeaderComponent implements OnInit, OnDestroy {
  currentUser: User;
  isLoading: boolean = false;
  SignatureSessionBehaviorEnum = SignatureSessionBehaviorEnum;
  @Input() hideCurrentUser = false;
  @Input() sessionBehavior?: SignatureSessionBehaviorEnum;

  constructor(
    public whitelabelService: WhitelabelService,
    public urlParamsService: UrlParamsService,
    private appService: AppService,
    private userService: UserService,
    private router: Router
  ) {}

  ngOnInit() {
    this.isLoading = true;
    this.userService
      .watchCurrentUser()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: user => {
          this.currentUser = user;
          this.isLoading = false;
        }
      });
  }

  ngOnDestroy() {}

  isCurrentUserHidden() {
    return this.hideCurrentUser;
  }

  isWhitelabel() {
    return !this.appService.isAutentiqueDomain() && !!this.whitelabelService?.whitelabel?.domain;
  }

  shouldShowHeaderActions() {
    return this.sessionBehavior !== SignatureSessionBehaviorEnum.EphemeralSession || !this.isOnSigningPage();
  }

  isOnSigningPage() {
    return this.router.url.includes('/assinar');
  }
}
